import React from 'react';
import SupplierServiceCallCalendarPageV2 from './SupplierServiceCallCalendarPageV2';

const SupplierServiceCallCalendarPageIndex = (props: any) => {
	return <SupplierServiceCallCalendarPageV2 {...props} />;
};

export default SupplierServiceCallCalendarPageIndex;
